<!-- 资料下载 -->
<template>
    <div class="el-dataDownload">
        <el-row class="page_content">
            <h1 class="head_title">资料下载</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column
                    prop="messageTitle"
                    header-align="center"
                    align="center"
                    label="资料标题">
                    <template slot-scope="scope">
                        <el-row v-html="scope.row.messageTitle"></el-row>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="courseResourceName"
                    header-align="center"
                    align="center"
                    label="资源名称">
                    <template slot-scope="scope">
                      <el-link :underline="false" type="primary" @click="seeNews(scope.$index)">
                        {{scope.row.courseResourceList[0].courseResourceName}}
                      </el-link>
                    </template>
                </el-table-column>
                <el-table-column
                prop="teacherName"
                header-align="center"
                align="center"
                label="上传人"
                width="180">
                </el-table-column>
                <el-table-column
                prop="messageAddTime"
                header-align="center"
                align="center"
                label="资源发布时间"
                width="180">
                </el-table-column>
                <el-table-column
                prop="messageAcceptState"
                header-align="center"
                align="center"
                label="资源状态"
                width="180">
                <template slot-scope="scope">
                    <span :class="scope.row.messageAcceptState === 1?'':'wd'">{{scope.row.messageAcceptState == 1?'已读':'未读'}}</span>
                </template>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "DataDownload",
  data() {
    return {
      tableData: [],
        submitBut:false
    };
  },
  created() {
    this.getCourseResourceList();
  },
  methods: {
    seeNews(index){
      this.downloadFeedback(index);
      window.open(this.$baseUrl + this.tableData[index].courseResourceList[0].courseResourceUrl);
    },
    getCourseResourceList(){ //获取资料下载 列表
      this.$store.dispatch("user/getCourseResourceList").then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.tableData = ret.data;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      })
    },
    downloadFeedback(index){ //点击下载后的反馈
      this.$store.dispatch("user/downloadFeedback",{messageAcceptId:this.tableData[index].messageAcceptId}).then((ret) => {
        if (ret.code != 0 && ret.code != '0') {
          
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }else{
          this.tableData[index].messageAcceptState = 1;
        }
      })
    }
  }
};
</script>
<style  lang="less">
  @import '../styles/base.less';
  .el-dataDownload{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/DataDownload.vue